import React from 'react';
import {
	CrossHatchThickPattern,
	CrossHatchThinPattern,
} from './CrossHatchPattern';

export const CheckersPatternThin = (props) => {
	return <CrossHatchThinPattern patternTransform="rotate(45)" {...props} />;
};
export const CheckersPatternThick = (props) => {
	return <CrossHatchThickPattern patternTransform="rotate(45)" {...props} />;
};
